module.exports = __webpack_public_path__ + "static/media/icon_robot_body_english.dd761a90.svg";